import { autoinject } from 'aurelia-framework';

import { GenericApi } from '~/api/generic-api';
import { EntityType } from '~/models/entities/entity-type';
import { FieldModel } from '~/models/form-model';
import { SearchResponse } from '~/models/search-response';
import { FetchUtils } from '~/utils/fetch-utils';

export interface MemberSearchResult extends MemberSearchResultBackend {
	entityType: EntityType.MEMBER;
}

export interface MemberSearchResultBackend {
	fieldModel?: {
		D2z_Title?: FieldModel;
		MDz_Status?: FieldModel;
	};
	values: {
		CTz_Description: string;

		D2d_Birth: string;
		D2z_Address_Line_1: string;
		D2z_Address_Line_2: string;
		D2z_Address_Line_3: string;
		D2z_Client: string;
		D2z_Country: string;
		D2z_Email: string;
		D2z_Email2: string;
		D2z_Given_Names: string;
		D2z_Middle_Names: string;
		D2z_Home_Phone: string;
		D2z_Mobile_Phone: string;
		D2z_Post_Code: string;
		D2z_Prev_Post_Code: string;
		D2z_Previous_Line_1: string;
		D2z_Previous_Line_2: string;
		D2z_Previous_Line_3: string;
		D2z_Previous_State: string;
		D2z_Previous_Suburb: string;
		D2z_Res_Addr_Line_1: string;
		D2z_Res_Addr_Line_2: string;
		D2z_Res_Addr_Line_3: string;
		D2z_Res_Country: string;
		D2z_Res_Post_Code: string;
		D2z_Res_State: string;
		D2z_Res_Suburb: string;
		D2z_State: string;
		D2z_Suburb: string;
		D2z_Surname: string;
		D2z_Title: string;
		D2z_Work_Phone: string;

		MDz_Category: string;
		MDz_Fund: string;
		MDz_Member: string;
		MDz_Status: string;

		// Fields only retrieved on getMember() endpoint
		// This is why they're all marked as optional.
		MDz_Given_Names?: string;
		MDz_Middle_Names?: string;
		MDz_Surname?: string;
		MDz_Acct_No?: string;
		MDz_Cust_No?: string;

		FRc_Division?: string;
	};

	// Fields only retrieved on getMember() endpoint.
	// This is why they're all marked as optional.
	activeAcctNo?: number;
	inactiveAcctNo?: number;
	status?: MemberStatus;
}

interface MemberStatus {
	backgroundColor: string;
	borderColor: string;
	text: string;
	textColor: string;
}

@autoinject
export class MemberSearchApi {
	public getSearchResults(
		query: string,
		searchAllDivision?: boolean,
	): Promise<SearchResponse<MemberSearchResult>> {
		let searchAllDivisionStatus = false;
		if (searchAllDivision) {
			searchAllDivisionStatus = searchAllDivision;
		}
		return FetchUtils.getJSON<SearchResponse<MemberSearchResult>>(
			'api/member/search',
			{
				q: query,
				'field-model': true,
				searchAllDivision: searchAllDivisionStatus,
				// NOTE: Jake: 2019-05-24 - WEBUI-1991
				// If null is given, then the backend uses the default configured value
				// which is currently 10 at time of writing. (Config::searchDefaultNumber)
				// number: ENTITY_SEARCH_RESULT_LIMIT,
			},
		).then((response) => {
			for (const item of response.data) {
				item.entityType = EntityType.MEMBER;
			}
			return response;
		});
	}

	public getMember(
		fund: string,
		member: string,
		excludeStatusReport: boolean,
	): Promise<MemberSearchResult> {
		/* let url = GenericApi.apiServerURL + `api/member/${fund}/${member}`;
		if (excludeStatusReport) {
			url += '?excludeStatusReport=true';
		}*/
		return FetchUtils.getJSON<MemberSearchResult>(
			`api/member/${fund}/${member}`,
			{
				excludeStatusReport: excludeStatusReport ? true : undefined,
			},
		).then((data): MemberSearchResult => {
			data.entityType = EntityType.MEMBER;
			return data;
		});
	}
}
